import { DialogOrderTypes, IntegrationsList, IOrderItem, IPlacedOrder, IProcessedOrdersDetails } from "../constants";
import Styles from "../../../scss/orderDetails.module.scss";
import { ChevronRight } from "@material-ui/icons";
import React, { useMemo, useState } from "react";
import { OrderStatus } from "../../../interfaces/EOrderStatus";
import { useSelector } from "react-redux";
import { IReduxAppState } from "../../../reducers";
import { useTranslation } from "react-i18next";
import { OrderActionButtons } from "./OrderActionButtons";
import { useAPIV2 } from "../../../yoello-lib/modules/API2/useAPIv2";
import APIExtensions from "../../../yoello-lib/modules/API2/APIDefs";
import { HTTPMethods } from "../../../yoello-lib/modules/API/API";
import { ICollectionPoint } from "../../ordersSetting/Forms/CollectionPointEntity";
import { generateQRCodeURL } from "../../../services/generateConsumerURLs";
// import { useHandleModalStages } from "../../../hooks/useHandleModalsStages";
import { refundReasonObj, RefundReasons } from "../PartialRefund/types";
import { useDialogRouteStages } from "../../dialogRoutes/useDialogRouteStages";
import { dialogKeys, ISSUE_REFUND_URL, REFUND_REASONS_URL } from "../../../const/URL.const";
import EColourPanel from "../../../interfaces/EColourPanel";
import { onIssueRefund, openReasonsDialog } from "../PartialRefund/utiles";
import useFormatCurrency from "../../../yoello-lib/modules/localisation/useCurrency";
import { OBRefundDialog } from "../Dialogs/OBRefundDialog";
import { EPaymentMethods } from "./PaymentMethods";
import { OnboardingSources } from "../../signup/types";
interface IOrderDetailActionsProps {
    dialogType: DialogOrderTypes;
    placed_order: IPlacedOrder;
    orderDetails: IProcessedOrdersDetails;
    inOrder: IOrderItem[];
    orderAPI: any;
    collectionPoints: ICollectionPoint[];
    setMessageOptions: (value: boolean) => void;
    onClose: () => void;
    path: string;
    history: any;
    orderOnly?:boolean;
}


export function OrderDetailsActions({ dialogType, placed_order, onClose, inOrder, orderAPI, collectionPoints, setMessageOptions, orderDetails, path, history, orderOnly }: IOrderDetailActionsProps) {
    const subscription = useSelector((state: IReduxAppState) => state.subscription);
    const selectedVenueId = useSelector((state: IReduxAppState) => state.selectedVenueId);
    const venue = useSelector((state: IReduxAppState) => state.venue[selectedVenueId].venueData);
    const isEposNow = useSelector((state: IReduxAppState) => state.isEposNow);
    const isPAY360Venue = (venue?.payment_processor === "PAY360");
    const { t } = useTranslation();
    const { formatCurrency } = useFormatCurrency();
    const { callAPI: callPlacedOrders } = useAPIV2(APIExtensions.placedOrders, { onMountDisabled: true });
    const { goToNextStep, goToPrevStep } = useDialogRouteStages(history);
    const [isRefundDialogOpen, setIsRefundDialogOpen] = useState(false);
    const isOpenBankingOrder = placed_order.placed_order_payment_method === EPaymentMethods.BANK_TRANSFER;
    const isIntegration = IntegrationsList.includes(venue?.onboarding_source?.toUpperCase() as OnboardingSources);

    const actionButtons = useMemo(() => {
        if (placed_order.placed_order_order_status === OrderStatus.PROCESSING_REFUND ) {
            return
        }
        const actionButtons = [];
        const status = placed_order.placed_order_order_status;
        const declineDialog = {
            label: t('forms.orders.status.decline'),
            onClick: () => isOpenBankingOrder ? setIsRefundDialogOpen(true) : openReasonsDialog(dialogKeys.ORDER, dialogKeys.PARTIALREFUNDREASONS, `${path}/${placed_order.placed_order_id}${REFUND_REASONS_URL}`, placed_order.placed_order_order_status === OrderStatus.FINISHED, placed_order, t, goToNextStep, goToPrevStep, orderDetails, <ChevronRight />, undefined, isPAY360Venue || isEposNow),
            colour: "#FF0000"
        }
        const refundStatus = {
            label: t('openBanking.refund.refund'),
            onClick: () => setIsRefundDialogOpen(true),
            colour: "#FA7800"
        }
        switch (dialogType) {
            case DialogOrderTypes.ORDER_HISTORY:
                if (canVoidOrder(status, subscription)) {
                    const refundReasons: refundReasonObj[] = [
                        {
                            key: RefundReasons.REFUNDENTIRE,
                            title: status === OrderStatus.PARTIALLY_REFUNDED ? "PartialReafund.OrderHistory.Void.Reasons.RefundRemainingOrder"
                                : "PartialReafund.OrderHistory.Void.Reasons.RefundEntireOrder",
                            label: t("PartialReafund.OrderHistory.Void.Reasons.Label"),
                            totalPrice: t("PartialReafund.OrderHistory.Total", { totalPrice: formatCurrency(placed_order.placed_order_order_total - placed_order.total_refund_amount) }),
                            hide: false
                        },
                        {
                            key: RefundReasons.SPECIALITEMS,
                            title: "PartialReafund.OrderHistory.Void.Reasons.RefundSpecificItems",
                            hide: !(!isPAY360Venue && !isEposNow && orderDetails.in_order.find(order => (order.in_order_group_quantity - order.in_order_group_quantity_refunded > 0 && !order.in_order_sold_as_extra)))
                        }
                    ]
                    const normalRefund = {
                        label: t('forms.orders.status.refund'),
                        onClick: () => onIssueRefund(dialogKeys.ORDER, dialogKeys.PARTIALREFUND, `${path}/${placed_order.placed_order_id}${ISSUE_REFUND_URL}`, placed_order, goToNextStep, goToPrevStep, refundReasons, {
                            label: t("PartialReafund.OrderHistory.Void.ConfirmButton"),
                            color: EColourPanel.PRIMARY,
                            Icon: <ChevronRight />,
                        },
                            t("PartialReafund.OrderHistory.Void.Title"),
                            t("PartialReafund.OrderHistory.Void.DialogTitle"), orderDetails),
                        colour: "#FA7800",
                        isRefund: (dialogType === DialogOrderTypes.ORDER_HISTORY)
                    }
                    //check if it is openbankin g order or not
                    !orderOnly && actionButtons.push( isOpenBankingOrder ? refundStatus : normalRefund );
                }
                if (canDecline(status, subscription) && !isIntegration) {
                    actionButtons.push(declineDialog);
                }
                break;
            case DialogOrderTypes.NEW_ORDERS:
                if(!isIntegration){
                    actionButtons.push(declineDialog);
                actionButtons.push({
                    label: t("orderHistory.modal.accept"),
                    onClick: async () => {
                        await callPlacedOrders(HTTPMethods.PUT, {
                            query: `${placed_order.placed_order_id}/status`,
                            body: {
                                new_status: "ACCEPTED"
                            },
                            errorCall: t('order.acceptDialog.apiError')
                        })
                        setMessageOptions(true);
                        onClose();
                    },
                    colour: "#24C277"
                })
                }
                
                break;
            case DialogOrderTypes.OPEN_ORDERS:
                if(!isIntegration){
                    actionButtons.push(declineDialog);
                }
                if (placed_order.placed_order_order_type === "COLLECTION_POINT_PICKUP" &&
                    placed_order.placed_order_order_status !== "READY_FOR_COLLECTION"
                    && placed_order.placed_order_collection_point_id !== null) {
                    actionButtons.push({
                        label: t("orderHistory.modal.readyCollection"),
                        colour: "#1D8BF7",
                        onClick: async () => {
                            const index = collectionPoints?.findIndex((item) => item.id === placed_order.placed_order_collection_point_id) ?? -1;
                            await callPlacedOrders(HTTPMethods.PUT, {
                                query: `${placed_order.placed_order_id}/status`,
                                body: {
                                    new_status: "READY_FOR_COLLECTION",
                                    template_placeholders: {
                                        placed_order_hash_id: placed_order.placed_order_hash_id,
                                        qr_access_code_url: generateQRCodeURL(placed_order.placed_order_id),
                                        collection_point_name: index > -1 ? collectionPoints![index].name : undefined,
                                    }
                                }
                            })
                            setMessageOptions(true);
                            onClose();
                        }
                    })
                } else if (!(placed_order.placed_order_order_type === "COLLECTION_POINT_PICKUP" && placed_order.placed_order_order_status === "ACCEPTED" && !isIntegration) ) {
                    actionButtons.push({
                        label: t("orderHistory.modal.finish"),
                        onClick: async () => {
                            await callPlacedOrders(HTTPMethods.PUT, {
                                query: `${placed_order.placed_order_id}/status`,
                                body: {
                                    new_status: "FINISHED"
                                },
                                errorCall: t('order.acceptDialog.apiError')
                            })
                            setMessageOptions(true);
                            onClose();
                        },
                        colour: "#24C277"
                    })
                }
                break;
        }
        return actionButtons;
        //eslint-disable-next-line
    }, [dialogType, inOrder, placed_order]);
    
    function getInOrderIds(){
        let inOrderIds: Record<string, number> = {}
        inOrder.forEach((item) => inOrderIds[item.in_order_id] = item.in_order_group_quantity)
        return inOrderIds;
    }

    return <>
        <div data-componnent-name="ActionButtons" className={Styles.dialogButtons}>
            {actionButtons && actionButtons.map(OrderActionButtons)}
        </div>
        <OBRefundDialog isRefund={dialogType === DialogOrderTypes.ORDER_HISTORY} isOpen={isRefundDialogOpen} onClose={() => setIsRefundDialogOpen(false)} venueId={selectedVenueId}
            inOrderIds={getInOrderIds()} orderId={placed_order.placed_order_id} consumer={orderDetails.consumer} history={history}/>
    </>
}

function canDecline(status: OrderStatus, subscription: string) {
    if (((status === OrderStatus.PLACED ||
        status === OrderStatus.FUNDS_RECEIVED ||
        status === OrderStatus.READY_FOR_COLLECTION ||
        status === OrderStatus.ACCEPTED || status === OrderStatus.PAYMENT_PROCESSING)
        && subscription !== 'SQUARE')) {
        return true;
    }
    return false;
}

function canVoidOrder(status: OrderStatus, subscription: string) {
    if ((status === OrderStatus.FINISHED || status === OrderStatus.PARTIALLY_REFUNDED) && subscription !== "SQUARE") {
        return true;
    }
    return false;
}
